import React from "react";
import { useParams } from "react-router-dom";
import { events } from "../util/eventData";
import "./EventPage.css";

const EventPage: React.FC = () => {
  const { eventSlug } = useParams<{ eventSlug: string }>();
  const event = events.find((e) => e.slug === eventSlug);

  if (!event) {
    return (
      <div className="event-page-container">
        <h2>Event not found</h2>
      </div>
    );
  }

  return (
    <div className="event-page-container">
      <div className="event-card">
        <img src={event.imageUrl} alt={event.name} className="event-image" />
        <div className="event-details">
          <h1>{event.name}</h1>
          <p>
            <strong>Date:</strong> {event.date}
          </p>
          <p>
            <strong>Time:</strong> {event.time}
          </p>
          <p>
            <strong>Venue:</strong> {event.venue.name}
          </p>
          <p>{event.venue.address}</p>
          <a
            href={event.venue.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            View on Map
          </a>
          <p className="event-description">{event.description}</p>
          <p>
            <strong>RSVP by:</strong> {event.rsvpDeadline}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventPage;
